import { render } from "./Diet.vue?vue&type=template&id=b289f098&scoped=true&lang=pug"
import script from "./Diet.vue?vue&type=script&lang=js"
export * from "./Diet.vue?vue&type=script&lang=js"

import "./Diet.vue?vue&type=style&index=0&id=b289f098&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b289f098"]])

export default __exports__